<template>
  <div class="ut-container-lg"> 
    <prospecting-dashboard-summary v-if="isProspectingAgent && hasCRMIntegration" />
    <Prospecting-plug-n-play v-else-if="isPrincipal && hasProspectorService" />
    <div v-else-if="redirectTrue">
        {{ notFoundRedirect() }}
    </div>
    <div v-else
         class="ut-p-10">
      <loading-spinner class="ut-mt-0" />
    </div>
  </div>
</template>

<script>
import { mapState, mapGetters } from 'vuex';
import LoadingSpinner from '@/components/Animations/LoadingSpinner.vue';
import ProspectingDashboardSummary from '@/components/Prospecting/ProspectingDashboard/ProspectingDashboardSummary.vue';
import ProspectingPlugNPlay from '@/components/Prospecting/ProspectingPlugNPlay.vue';

export default {
  name: 'Prospecting',
  components: {
    LoadingSpinner,
    ProspectingDashboardSummary,
    ProspectingPlugNPlay,
  },
  data() {
    return {};
  },
  computed: {
    ...mapState({
      user: state => state.userStore.user,
      userProspectorStatus: state => state.userStore.userProspectorStatus,
    }),
    ...mapGetters('userStore', [
      'isProspectingAgent',
      'isPrincipal',
      'hasProspectorService',
      'hasCRMIntegration',
    ]),
    redirectTrue() {
      if (this.user.key && this.userProspectorStatus && (!this.userProspectorStatus.isProspectingAgent
        || (!this.userProspectorStatus.isPrincipal && !this.userProspectorStatus.hasProspectorService)
      )) {
        return true;
      }
      return false;
    },
  },
  methods: {
    notFoundRedirect() {
      this.$router.push({
        name: '404',
        params: { ak: this.$route.params.ak },
      });
    },
  },
};
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped lang="scss">
</style>
